module.exports = __webpack_public_path__ + "static/img/wechat.86dd057.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/wechat.png
// module id = WnPA
// module chunks = 1